import { connect } from 'react-redux';

import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmDataResigningRequired } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { PM_RESULT_OF_INSPECTION } from 'CorePackage/MainModule/routes/routes';
import { KnmLateFieldsRemark } from 'KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

import styles from './PmResultOfInspectionItem.module.scss';

interface IPmResultOfInspectionItemResultOfInspectionProps {
  watchOnly: boolean;
}

interface IPmResultOfInspectionItemResultOfInspectionStoreProps {
  resigningRequired: boolean;
}

export const PmResultOfInspectionItemResultOfInspectionWithoutStore = ({
  watchOnly,
  resigningRequired,
}: IPmResultOfInspectionItemResultOfInspectionProps & IPmResultOfInspectionItemResultOfInspectionStoreProps) => {
  return (
    <div className={styles.ResultOfInspectionFieldBlock} id={PM_RESULT_OF_INSPECTION}>
      <div className="shared-group-margin">
        <label className="shared-group-label" htmlFor="resultOfInspection">
          Результат профилактического мероприятия
        </label>
        <KnmLateFieldsRemark lateFieldPath="/resultOfInspection" fieldId="resultOfInspection" />
      </div>
      <TextareaField
        inputClassName={styles.ResultOfInspectionInput}
        id="resultOfInspection"
        name="resultOfInspection"
        disabled={watchOnly || resigningRequired}
      />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IPmResultOfInspectionItemResultOfInspectionStoreProps => ({
  resigningRequired: getKnmDataResigningRequired(state),
});

export const PmResultOfInspectionItemResultOfInspection = connect(mapStateToProps)(
  PmResultOfInspectionItemResultOfInspectionWithoutStore,
);
